(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-inside-illustration"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const chips = document.querySelectorAll('.whats-inside-illustration__chip');

    chips.forEach((chip) => {
      chip.addEventListener('click', function () {
        // Remove active class from all chips
        chips.forEach((c) => c.classList.remove('active'));

        // Add active class to clicked chip
        this.classList.add('active');

        // You can add additional functionality here
        const feature = this.dataset.feature;
        console.log('Selected feature:', feature);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
